import * as React from 'react'

function TabBody({ children }) {
  return <div className="bg-white px-4 pb-4 pt-3">{children}</div>
}

export default TabBody
